module.exports = __webpack_public_path__ + "img/accuracy.60928ac9.svg";